import React, { useState } from "react";
import { Modal, message } from "antd";
import { useOutletContext } from "react-router-dom";
import LanguageToggle from "./LanguageToggle";
import { useLanguage } from "../../../../context/LanguageContext";
import dashboardContent from "../../../../utils/dashboardContent";
import userService from "../../../../services/userService";
import { useNavigate } from "react-router-dom";
const DashboardSettings = () => {
  const [activeTab, setActiveTab] = useState("profile");
  const { user } = useOutletContext();
  const [emailNotif, setEmailNotif] = useState(
    user?.notificationSettings?.emailNotification ?? true
  );
  const [appNotif, setAppNotif] = useState(
    user?.notificationSettings?.appNotification ?? true
  );
  const navigate = useNavigate();

  const { language } = useLanguage();
  const text = dashboardContent[language].settings;

  const tabs = [
    { key: "profile", label: text.tabs.profile },
    { key: "subscription", label: text.tabs.subscription },
    { key: "notifications", label: text.tabs.notifications },
    { key: "language", label: text.tabs.language },
    { key: "other", label: text.tabs.other },
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-4 px-2 sm:px-6">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg">
        {/* Header */}
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-2xl font-semibold text-gray-800">{text.title}</h2>
          <p className="text-sm text-gray-500">{text.description}</p>
        </div>

        {/* Tabs Navigation */}
        <div className="border-b border-gray-200">
          <nav className="flex space-x-4 p-2 overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                className={`flex-shrink-0 px-4 py-2 font-medium text-sm rounded-lg whitespace-nowrap ${
                  activeTab === tab.key
                    ? "bg-orange-500 text-white"
                    : "text-gray-600 hover:bg-gray-100"
                }`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="p-6">
          {activeTab === "profile" && (
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                {text.profile.title}
              </h3>
              <form className="space-y-4">
                <div>
                  <label
                    htmlFor="name"
                    className="block text-sm font-medium text-gray-700"
                  >
                    {text.profile.name}
                  </label>
                  <input
                    type="text"
                    id="name"
                    disabled
                    value={user.name}
                    className="mt-1 block w-full border-gray-300 rounded-lg shadow-sm focus:ring-orange-500 focus:border-orange-500"
                  />
                </div>
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700"
                  >
                    {text.profile.email}
                  </label>
                  <input
                    type="email"
                    id="email"
                    disabled
                    value={user.email}
                    className="mt-1 block w-full border-gray-300 rounded-lg shadow-sm focus:ring-orange-500 focus:border-orange-500"
                  />
                </div>

                <button
                  type="button"
                  onClick={() => navigate("/dashboard/profile")}
                  className="bg-orange-500 text-white w-full sm:w-auto py-2 px-4 rounded-lg hover:bg-orange-600"
                >
                  {text.profile.save || "Profil bearbeiten"}
                </button>
              </form>
            </div>
          )}

          {activeTab === "subscription" &&
            user?.subscription &&
            (() => {
              const { subscription } = user;
              const { startDate, nextBillingDate, contractDuration } =
                subscription;

              const calculatedPeriodEnd =
                contractDuration > 1
                  ? new Date(
                      new Date(startDate).setMonth(
                        new Date(startDate).getMonth() + contractDuration
                      )
                    )
                  : new Date(nextBillingDate);

              return (
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-4">
                    {text.subscription.title}
                  </h3>
                  <div className="space-y-2 text-sm text-gray-700">
                    <p>
                      <strong>{text.subscription.plan}</strong>{" "}
                      {subscription.planName}
                    </p>
                    <p>
                      <strong>{text.subscription.status}</strong>{" "}
                      {subscription.status === "active" ||
                      subscription.status === "incomplete"
                        ? language === "de"
                          ? "Aktiv"
                          : "Active"
                        : subscription.status}
                    </p>
                    <p>
                      <strong>{text.subscription.startDate}</strong>{" "}
                      {new Date(subscription.startDate).toLocaleDateString(
                        language === "de" ? "de-DE" : "en-US"
                      )}
                    </p>
                    <p>
                      <strong>{text.subscription.currentPeriodEnd}</strong>{" "}
                      {calculatedPeriodEnd.toLocaleDateString(
                        language === "de" ? "de-DE" : "en-US"
                      )}
                    </p>
                    <p>
                      <strong>{text.subscription.nextBillingDate}</strong>{" "}
                      {new Date(
                        subscription.nextBillingDate
                      ).toLocaleDateString(
                        language === "de" ? "de-DE" : "en-US"
                      )}
                    </p>
                    <p>
                      <strong>{text.subscription.contractDuration}</strong>{" "}
                      {subscription.contractDuration}{" "}
                      {language === "de" ? "Monate" : "months"}
                    </p>
                    <p>
                      <strong>{text.subscription.pendingCancellation}</strong>{" "}
                      {subscription.pendingCancellation
                        ? language === "de"
                          ? "Kündigung vorgemerkt"
                          : "Pending cancellation"
                        : language === "de"
                        ? "Nicht gekündigt"
                        : "Not cancelled"}
                    </p>
                  </div>

                  <button
                    onClick={() => navigate("/dashboard/abomanagement")}
                    className="mt-6 bg-orange-500 text-white w-full sm:w-auto py-2 px-4 rounded-lg hover:bg-orange-600"
                  >
                    {text.subscription.button}
                  </button>
                </div>
              );
            })()}

          {activeTab === "notifications" && (
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                {text.notifications.title}
              </h3>
              <div className="space-y-4">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="email-notifications"
                    className="h-4 w-4 text-orange-500 border-gray-300 rounded focus:ring-orange-400"
                    checked={emailNotif}
                    onChange={async () => {
                      const newValue = !emailNotif;
                      setEmailNotif(newValue);
                      try {
                        await userService.updateProfile({
                          notificationSettings: {
                            emailNotification: newValue,
                            appNotification: appNotif,
                          },
                        });
                      } catch (err) {
                        setEmailNotif(!newValue); // revert on error
                      }
                    }}
                  />
                  <label
                    htmlFor="email-notifications"
                    className="ml-2 text-sm text-gray-800"
                  >
                    {text.notifications.email}
                  </label>
                </div>

                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="app-notifications"
                    className="h-4 w-4 text-orange-500 border-gray-300 rounded focus:ring-orange-400"
                    checked={appNotif}
                    onChange={async () => {
                      const newValue = !appNotif;
                      setAppNotif(newValue);
                      try {
                        await userService.updateProfile({
                          notificationSettings: {
                            emailNotification: emailNotif,
                            appNotification: newValue,
                          },
                        });
                      } catch (err) {
                        setAppNotif(!newValue); // revert on error
                      }
                    }}
                  />
                  <label
                    htmlFor="app-notifications"
                    className="ml-2 text-sm text-gray-800"
                  >
                    {text.notifications.app}
                  </label>
                </div>
              </div>
            </div>
          )}

          {activeTab === "language" && (
            <div>
              <LanguageToggle />
            </div>
          )}
          {activeTab === "other" && (
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                {text.other.title}
              </h3>

              <button
                onClick={async () => {
                  try {
                    await userService.exportData();
                  } catch (err) {
                    console.error(err);
                  }
                }}
                className="bg-gray-200 text-gray-800 w-full sm:w-auto py-2 px-4 rounded-lg hover:bg-gray-300 mr-2"
              >
                {text.other.export}
              </button>

              <button
                danger
                type="primary"
                className="mt-4 bg-red-500 text-white w-full sm:w-auto py-2 px-4 rounded-lg hover:bg-red-600"
                onClick={() => {
                  Modal.confirm({
                    title: text.other.confirmTitle || "Konto wirklich löschen?",
                    content:
                      text.other.confirmDelete ||
                      "Dies kann nicht rückgängig gemacht werden. Bist du sicher?",
                    okText: text.other.confirmYes || "Ja, löschen",
                    cancelText: text.other.confirmCancel || "Abbrechen",
                    okButtonProps: { danger: true },
                    onOk: async () => {
                      try {
                        await userService.deleteAccount();
                        localStorage.clear();
                        message.success(
                          text.other.deleted || "Konto gelöscht."
                        );
                        navigate("/login");
                      } catch (err) {
                        console.log(err);
                      }
                    },
                  });
                }}
              >
                {text.other.delete}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardSettings;
